export default __webpack_public_path__ + "static/media/free-stamp.6c080b2e.png";